import React from "react";
import { inject } from "mobx-react";
import { defaultTemplate } from 'core/hoc';
import { BaasicAcknowledgeErrorsTemplate } from "themes/components";

function BaasicAcknowledgeErrorsModal(props) {
    return <BaasicAcknowledgeErrorsTemplate {...props} />;
}

export default inject((i, props) => {
    return {
        modalParams: props.modalParams || i.rootStore.modalStore.confirmParams
    };
})(defaultTemplate(BaasicAcknowledgeErrorsModal));
